import { useRootSelector } from "@modules/store/redux"
import { temporaryPasswordSelector } from "./selectors"

export const useHasTemporaryPwd = () =>
  useRootSelector(temporaryPasswordSelector)
